import { RSAA } from 'redux-api-middleware';
import { BeneficiaryEvents, EVENT_CONSTANTS } from 'web-lib-application-essentials/lib/businessEvents';
import endpoints from '../../../utils/endpoints';
import {
	getAddNewPayeeRequest,
	getAddInternationalNewPayeeRequest,
	getBeneficiaryCreateEventAttribute,
	getBeneficiaryUpdateEventAttribute,
} from '../../../helpers/apiRequestBuilder';
import { headers } from '../../../store/middlewares/createApiMiddleware';
import { getAddMultiplePaymentsFlag, isPaymentFlow, getAddPayeePaymentDetails } from './selectors';
import { getIsAddingNewRow } from '../../../states/modes/selectors';
import { getSelectedPaymentId } from '../../../states/payeeSelector/selectors';
import {
	getPaymentTypeOrPayeeType,
	isAuthorisationEdit,
	isAuthorisationEditById,
} from '../../../states/modes/selectors';
import { postAddPayeeUpdatePayment, updatePayment } from '../../../states/payments/actions';
import {
	chapsUpdateSinglePaymentAccount,
	postAddPayeeUpdateChapsPayment,
	submitChapsReview,
} from '../../../states/chaps/actions';
import { goToPayments, goToPaymentsPage, goToDebitPaymentsPage, pages, goToPage } from '../../../states/page/actions';
import { addPayment as addBacsDebitPayment, updateBacsDebitPayment } from '../../../states/bacsDebit/actions';
import { postAddPayeeUpdateBacsPayment, updateBacsCreditPayment } from '../../../states/bacsCredit/actions';
import { TYPE_BACS_CREDIT, TYPE_BACS_DEBIT, TYPE_FASTER_PAYMENTS, TYPE_CHAPS, TYPE_IFT } from '../../../config';
import { getBankId } from '../../../states/session/selectors';
import { iftAddPayments } from '../../../states/ift/actions';
import { setDuplicatePayeeSubmitted, setAccountError } from '../../../states/payees/actions';
import get from 'lodash/get';
import { submitReview } from '../../../states/api/fasterPaymentActions';
import { submitBacsPaymentsForReview } from '../../../states/api/bacsActions';
export const UPDATE_ADD_PAYEE_FORM = 'UPDATE_ADD_PAYEE_FORM';
export const SET_ADD_PAYEE_FORM = 'SET_ADD_PAYEE_FORM';
export const DELETE_VALIDATION_FIELD = 'DELETE_VALIDATION_FIELD';
export const RESET_ADD_PAYEE_FORM = 'RESET_ADD_PAYEE_FORM';
export const RESET_ADD_PAYEE_FORM_ERRORS = 'RESET_ADD_PAYEE_FORM_ERRORS';
export const SUBMIT_ADD_PAYEE_REQUEST = 'SUBMIT_ADD_PAYEE_REQUEST';
export const SUBMIT_ADD_PAYEE_SUCCESS = 'SUBMIT_ADD_PAYEE_SUCCESS';
export const SUBMIT_ADD_PAYEE_FAILURE = 'SUBMIT_ADD_PAYEE_FAILURE';
export const SUBMIT_ADD_INTERNATIONAL_PAYEE_REQUEST = 'SUBMIT_ADD_INTERNATIONAL_PAYEE_REQUEST';
export const SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS = 'SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS';
export const SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE = 'SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE';
export const INIT_ADD_PAYEE_FORM = 'INIT_ADD_PAYEE_FORM';
export const SET_GENERIC_ERROR = 'SET_GENERIC_ERROR';

const createPayment = ({
	isNotToAccountSelection,
	selectedPaymentId,
	payment,
	response,
	addAction,
	updateAction,
	dispatch,
	goToAction,
	isEdit,
}) => {
	if (isNotToAccountSelection) {
		dispatch(addAction(payment, response, isEdit));
	} else {
		dispatch(
			updateAction({
				id: selectedPaymentId || payment.id,
				accountId: response.id,
				reference: response.reference,
			})
		);
	}
	if (goToAction) {
		dispatch(goToAction(payment.toAccount));
	}
};
//REFACTOR: We should not have this big switch statement - we should be passing the correct action as a callback handler from the originating code as per Inversion of Control principle
export const submitAddPayeePostActions = (state, response, dispatch, isEdit = false) => {
	const paymentTypeOrPayeeType = getPaymentTypeOrPayeeType(state);
	const payment = getAddPayeePaymentDetails(state, response);
	const selectedPaymentId = getSelectedPaymentId(state);
	const isNotToAccountSelection = getAddMultiplePaymentsFlag(state);
	const commonPaymentParams = { isNotToAccountSelection, selectedPaymentId, payment, response, dispatch };
	const redirectToReview = !getIsAddingNewRow(state);
	switch (paymentTypeOrPayeeType) {
		case TYPE_BACS_CREDIT: {
			createPayment({
				...commonPaymentParams,
				id: payment.id,
				addAction: postAddPayeeUpdateBacsPayment,
				updateAction: updateBacsCreditPayment,
				goToAction: isAuthorisationEdit(state) && redirectToReview ? submitBacsPaymentsForReview : goToPaymentsPage,
				isEdit,
			});
			break;
		}
		case TYPE_BACS_DEBIT: {
			createPayment({
				...commonPaymentParams,
				addAction: addBacsDebitPayment,
				updateAction: updateBacsDebitPayment,
				goToAction: goToDebitPaymentsPage,
			});
			break;
		}
		case TYPE_FASTER_PAYMENTS: {
			createPayment({
				...commonPaymentParams,
				id: payment.id,
				addAction: postAddPayeeUpdatePayment,
				updateAction: updatePayment,
				goToAction: isAuthorisationEdit(state) && redirectToReview ? submitReview : goToPayments,
				isEdit,
			});

			break;
		}
		case TYPE_CHAPS: {
			if (isNotToAccountSelection) {
				// Not selection of To account, hence create a new payment
				dispatch(postAddPayeeUpdateChapsPayment(payment));
			} else {
				// Update an existing payment's accounts
				dispatch(
					chapsUpdateSinglePaymentAccount(
						payment,
						selectedPaymentId || payment.id,
						get(response, 'reference_high_value', get(response, 'reference', ''))
					)
				);

				if (isAuthorisationEdit(state) || isAuthorisationEditById(state)) {
					dispatch(submitChapsReview());
					return;
				}

				dispatch(goToPage(pages.ChapsPayments));
			}
			break;
		}
		case TYPE_IFT: {
			dispatch(iftAddPayments(payment));
			dispatch(goToPage(pages.IFTPayments));
			break;
		}
		default:
			break;
	}
};

export const initAddPayeeForm = (id, initialValues = {}) => ({
	type: INIT_ADD_PAYEE_FORM,
	id,
	initialValues,
});
export const BENEFICIARY_EVENTS_FAILURE = 'BENEFICIARY_EVENTS_FAILURE';

export const updateAddPayeeForm = (value) => ({
	type: UPDATE_ADD_PAYEE_FORM,
	value,
});

export const resetAddPayeeForm = (id) => ({
	type: RESET_ADD_PAYEE_FORM,
	id,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const resetAddPayeeFormErrors = () => ({
	type: RESET_ADD_PAYEE_FORM_ERRORS,
});

export const setAddPayeeForm = (payeeDetails) => ({
	type: SET_ADD_PAYEE_FORM,
	payeeDetails,
});

export const beneficiaryEventsFailure = () => ({
	type: BENEFICIARY_EVENTS_FAILURE,
});

export const setGenericError = (errorCode) => ({
	type: SET_GENERIC_ERROR,
	errorCode,
});

export const createBeneficiaryEvent = ({ bankId, apiBaseUrlPaas, addPayeeForm, clientContext, errorCallback, token }) =>
	BeneficiaryEvents.createBeneficiaryEvent({
		action: EVENT_CONSTANTS.METHOD.INTERACTED,
		attribute: getBeneficiaryCreateEventAttribute(addPayeeForm),
		eventRequest: {
			headers: {
				...headers(clientContext),
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
			apiUrl: apiBaseUrlPaas,
			bankId,
		},
		errorCallback,
	});
export const updateBeneficiaryEvent = ({ bankId, apiBaseUrlPaas, addPayeeForm, clientContext, errorCallback, token }) =>
	BeneficiaryEvents.updateBeneficiaryEvent({
		action: EVENT_CONSTANTS.METHOD.INTERACTED,
		attribute: getBeneficiaryUpdateEventAttribute(addPayeeForm),
		eventRequest: {
			headers: {
				...headers(clientContext),
				Accept: 'application/json',
				Authorization: `Bearer ${token}`,
			},
			apiUrl: apiBaseUrlPaas,
			bankId,
		},
		errorCallback,
	});

export const submitAddPayeeRequest =
	({ id, payeeDetails, account, copDetails, isEdit }) =>
	(dispatch, getState) => {
		const state = getState();
		const body = getAddNewPayeeRequest(payeeDetails, copDetails);
		const endpoint = endpoints.addPayee.resolve(getBankId(state), null, account.id);
		const type = payeeDetails.chapsPaymentsEnable ? 'chaps' : '';

		return dispatch({
			[RSAA]: {
				endpoint,
				method: 'POST',
				types: [
					SUBMIT_ADD_PAYEE_REQUEST,
					{
						type: SUBMIT_ADD_PAYEE_SUCCESS,
						meta: { account, type, isPaymentFlow: isPaymentFlow(state) },
					},
					{
						type: SUBMIT_ADD_PAYEE_FAILURE,
						meta: { id },
					},
				],
				body,
				headers: { 'x-bpi-version': endpoints.addPayee.x_bpi_version },
			},
		}).then((response) => {
			if (response.type === SUBMIT_ADD_PAYEE_FAILURE) {
				if (get(response, 'payload.status') === 409) {
					dispatch(setDuplicatePayeeSubmitted());
				} else if (get(response, 'payload.status') === 400) {
					dispatch(setAccountError(response.payload));
				}
				return { hasError: true };
			} else {
				submitAddPayeePostActions(getState(), response.payload, dispatch, isEdit);
				dispatch(resetAddPayeeForm(id));
			}
		});
	};

export const submitInternationalAddPayeeRequest = (id, payeeDetails, account) => (dispatch, getState) => {
	const state = getState();
	const body = getAddInternationalNewPayeeRequest(payeeDetails);
	const endpoint = endpoints.addInternationalPayee.resolve(getBankId(state), null, account.id);
	return dispatch({
		[RSAA]: {
			endpoint,
			method: 'POST',
			types: [
				SUBMIT_ADD_INTERNATIONAL_PAYEE_REQUEST,
				{
					type: SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS,
					meta: { account, type: 'international', isPaymentFlow: isPaymentFlow(state) },
				},
				{
					type: SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE,
					meta: { id },
				},
			],
			body,
			headers: { 'x-bpi-version': endpoints.addPayee.x_bpi_version },
		},
	}).then((response) => {
		if (response.type === SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS) {
			submitAddPayeePostActions(getState(), response.payload, dispatch);
		}
	});
};
